import React from 'react'
import budgetapp from './Images/budgetapp.PNG'
import todo from './Images/todo.png'
import techtraining from './Images/techtraining.png'
import mymeals from './Images/mymeals.png'
import pfe3 from './Images/pfe3.png'
import cleanit from './Images/cleanit.png'
import annotation from './Images/annotation.png'
import novytv from './Images/novytv.png'
export default function  () {
  return (
    <div className='portfolio' id='portfolio'>
        <h1 className='title'>PORTFOLIO</h1>

        <div className='projet' data-aos="fade-right">
            <div className='image'>
                <img src={novytv}/>
            </div>
            <div className='description'>
                <h1>
                    Novy-TV
                </h1>
                <p>
                This app allows you to create, modify, 
                delete and view ads on a tv 
                in the form of a slide and in fullscreen mode,
                created using NEXT.JS and FirebBase.
                </p>
            </div>
        </div>

        <div className='projet' data-aos="fade-left">
            <div className='image'>
                <img src={budgetapp}/>
            </div>
            <div className='description'>
                <h1>
                    BUDGET APP
                </h1>
                <p>
                This app helps you to create a budget and, in many cases,
                track your income and spending, created using REACT.JS.
                </p>
                <div className='buttons'>
                        <a className='code' href='https://github.com/WijdaneCHAR/Budget-App' target="_blank">
                        <button>
                            Code
                        </button>
                        </a>
                        <a  className='preview' href='https://cheery-eclair-32c96b.netlify.app/' target="_blank">
                        <button>
                            Preview
                        </button>
                        </a>
                </div>
            </div>
        </div>

        <div className='projet' data-aos="fade-right">
            <div className='image'>
                <img src={todo}/>
            </div>
            <div className='description'>
                <h1>
                    TO DO LIST
                </h1>
                <p>
                List of tasks you have to do, or things that you want to do, created using REACT.JS.
                </p>
                <div className='buttons'>
                        <a className='code' href='https://github.com/WijdaneCHAR/To-Do-List' target="_blank">
                        <button>
                            Code
                        </button>
                        </a>
                        <a  className='preview' href='https://polite-torrone-62fe1f.netlify.app/' target="_blank">
                        <button>
                            Preview
                        </button>
                        </a>
                </div>
            </div>
        </div>


        <div className='projet' data-aos="fade-left">
            <div className='image'>
                <img src={techtraining} style={{height:"500px",width:"60%"}}/>
            </div>
            <div className='description'>
                <h1>
                    TECHNTRAINING APP
                </h1>
                <p>
                The application allows to make reservations for training courses in computer development technologies,
                created using IONIC
                </p>
                <div className='buttons'>
                        <a className='code' href='https://github.com/WijdaneCHAR/TachTraining-App' target="_blank">
                        <button>
                            Code
                        </button>
                        </a>
                        <a  className='preview' href='https://drive.google.com/uc?export=download&id=18HtCPp-2RHkHPubP3bMAO58rV5CQp6je' target="_blank">
                        <button>
                            Preview
                        </button>
                        </a>
                </div>
            </div>
        </div>

        <div className='projet' data-aos="fade-right">
            <div className='image'>
                <img src={mymeals}/>
            </div>
            <div className='description'>
                <h1>
                    MY MEALS
                </h1>
                <p>
                The app contains different recipes for cooking, created using JAVASCRIPT and a free API from <a href='https://www.themealdb.com' target='_blank'>themealdb.com</a>
                </p>
                <div className='buttons'>
                        <a className='code' href='https://github.com/WijdaneCHAR/My-Meals' target="_blank">
                        <button>
                            Code
                        </button>
                        </a>
                        <a  className='preview' href='https://stunning-churros-b78e0f.netlify.app/' target="_blank">
                        <button>
                            Preview
                        </button>
                        </a>
                </div>
            </div>
        </div>

        <div className='projet' data-aos="fade-left">
            <div className='image'>
                <img src={pfe3}/>
            </div>
            <div className='description'>
                <h1>
                    PFE PROGRESS
                </h1>
                <p>
                The application allows the management, 
                the follow-up of the PFE projects and the 
                organization of the defenses, dedicated to 
                the students of the national school of applied
                sciences of Oujda, created by 3 students using ASP.NET 6 and REACT.JS
                </p>
            </div>
        </div>

        <div className='projet' data-aos="fade-right">
            <div className='image'>
                <img src={cleanit}  style={{height:"450px",width:"60%"}}/>
            </div>
            <div className='description'>
                <h1>
                    CLEAN IT
                </h1>
                <p>
                The application offers an online laundry service.
                allows the collection of laundry 
                to be washed and delivered to your home, created by 3 students using ANDROID 
                </p>
                <div className='buttons'>
                        <a className='code' href='https://github.com/WijdaneCHAR/Clean-It' target="_blank">
                        <button>
                            Code
                        </button>
                        </a>
                </div>
            </div>
        </div>

        <div className='projet' data-aos="fade-left">
            <div className='image'>
                <img src={annotation}/>
            </div>
            <div className='description'>
                <h1>
                ANNOTATION MANAGEMENT APPLICATION
                </h1>
                <p>
                A web application for the annotation of biomedical
                questions/answers in Arabic language.
                A project that will be the first of its kind for
                the Arabic language, and which will have a potential positive 
                impact in the field of health, this project had to be done in a group using PHP.
                </p>
                <div className='buttons'>
                        <a className='code' href='https://github.com/WijdaneCHAR/Gestion-Annotations' target="_blank">
                        <button>
                            Code
                        </button>
                        </a>
                </div>
            </div>
        </div>
    </div>
  )
}
